import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ScannerService {
  private scanResultSubjects = new Map<string, Subject<string>>();

  sendScanResult(instanceId: string, result: string): void {
    if (!this.scanResultSubjects.has(instanceId)) {
      this.scanResultSubjects.set(instanceId, new Subject<string>());
    }
    const subject = this.scanResultSubjects.get(instanceId);

    subject.next(result);
  }

  getScanResultObservable(instanceId: string): Observable<string> {
    if (!this.scanResultSubjects.has(instanceId)) {

      this.scanResultSubjects.set(instanceId, new Subject<string>());
    }

    return this.scanResultSubjects.get(instanceId).asObservable();
  }
}
